import React from 'react'
import { NavLink } from 'react-router-dom'
import Divider from '../Divider'

import './style.css'

export const Footer = ({ style, isAllowed }) => {
  return (
    <section className={'footer'} style={{ ...style, background: '#5E2751' }}>
      <div className='container'>
        <div className='row'>
          <NavLink to='/'>{isAllowed && <img src='/images/logo-ajg-w.png' width={60} alt='' />}</NavLink>
        </div>

        <Divider style={{ background: '#FFFFFF33' }} />
        <div className='column'>
          {/* <img src="images/iso27001.png" className="iso-27001-logo" alt="" /> */}
          <div className='row mob-column'>
            <NavLink
              to={
                isAllowed
                  ? 'https://www.penunderwriting.co.uk/legal-and-regulatory-information'
                  : 'https://www.rpsins.com/legal-information/'
              }
              target='_blank'
              className={'footer-link-item'}
            >
              Legal and Regulatory Information
            </NavLink>
            {isAllowed && (
              <NavLink
                to={'https://www.penunderwriting.co.uk/modern-slavery-act-2021'}
                target='_blank'
                className={'footer-link-item'}
              >
                Modern Slavery Act
              </NavLink>
            )}
            {isAllowed && (
              <NavLink
                to={'https://www.penunderwriting.co.uk/privacy-policy'}
                target='_blank'
                className={'footer-link-item'}
              >
                UK Privacy Notice
              </NavLink>
            )}
            <NavLink
              to={
                isAllowed
                  ? 'https://penunderwriting.eu/privacy-policy'
                  : 'https://www.rpsins.com/global-privacy-notice/'
              }
              target='_blank'
              className={'footer-link-item'}
            >
              EEA Privacy Notice
            </NavLink>
            <NavLink
              to={
                'https://www.penunderwriting.com.au/forms/proposals/important_informations/PEN-CMP005e-Privacy-Notice-incl-Addendum-v0525-Approved.pdf'
              }
              target='_blank'
              className={'footer-link-item'}
            >
              Australia Privacy Notice
            </NavLink>
            <NavLink
              to={'https://policy.cookiereports.com/02c842ec-en-gb.html'}
              target='_blank'
              className={'footer-link-item'}
            >
              Cookie Policy
            </NavLink>
          </div>
        </div>
        <div id='bottom-page' className='row'></div>
      </div>
    </section>
  )
}
